import { ReactNode } from "react";
import { useNotificationsHub } from "@/hooks/Notification/useNotificationsHub";
import { useUser } from "./UserContext";
import { UserRole } from "@/shared/constants";

interface Props {
  children: ReactNode;
}

export const NotificationProvider = ({ children }: Props) => {
  const { user } = useUser();
  const isLoaded = !!user;
  const isNotAdmin = isLoaded && !user.roles.includes(UserRole.ADMIN);

  useNotificationsHub(isLoaded ? isNotAdmin : false);

  return <>{children}</>;
};
